import { Typography } from "@mui/material";
import styled from "styled-components";

export const StyledTypography = styled(Typography)`
    && {
        font-weight: 400;
        font-size: 14px;
        line-height: 18px;
    }
`;
